import React from 'react'

const commonParams = (data) => {
    const newData = {
        size: data?.size? data?.size:20,
        page: data?.page? data?.page:0
    }

    const params = `?size=${newData.size}&page=${newData.page}`

  return params
}

export default commonParams
